/**
 * Here, we don't require a Shape View, and all it's assumptions.
 */

var BaseMoveFnMixin = require('./baseMoveFnMixin');


module.exports = {

    moveStart: function( x, y, e, dragHelper, onAfterMoveStart ) {

        e.preventDefault();
        e.stopImmediatePropagation();

        if ( dragHelper.dragOpacity && dragHelper.dragOpacity < 1 ) {
            this.el.animate( {opacity: dragHelper.dragOpacity}, 0, '>' );
        }

        dragHelper.originalOpacity =  this.el.attr('opacity');

        dragHelper.obox = this.el.getBBox();
        dragHelper.obx = dragHelper.obox.x;
        dragHelper.oby = dragHelper.obox.y;

        /* Adjusted dx, dy from moveMove taking boundaries into account ( really odx, ody ) */
        dragHelper.dx = 0;
        dragHelper.dy = 0;

        onAfterMoveStart && onAfterMoveStart.apply( this, arguments );

    },
    moveMove: function( dx, dy, x, y, e, dragHelper, onAfterMove ) {

        e.preventDefault();
        e.stopImmediatePropagation(); //(stop red dialog dd from closing)

        // Note: only not prevented now for graphic text stamps -- if we have a select set this could be problematic
        if ( dragHelper.getPreventDragOffCanvas() ) {

            /* Bounds check -- set dx, dy */
            var c = dragHelper.canvasBounds,
                odx = dragHelper.obx + dx,
                odx2 = dragHelper.obox.x2 + dx,
                ody = dragHelper.oby + dy,
                ody2 = dragHelper.obox.y2 + dy;

            if ( odx2 >= c.x2 ) {
                dx = c.x2 - dragHelper.obx - dragHelper.obox.width;
            } else if (odx <= c.x) {
                dx = c.x - dragHelper.obx;
            }

            if ( ody2 >= c.y2 ) {
                dy = c.y2 - dragHelper.oby - dragHelper.obox.height;
            } else if (ody <= c.y) {
                dy = c.y - dragHelper.oby;
            }

        }

        // This should be known to the caller ... maybe we start out with the obj model on start ... or retun the value
        dragHelper.dx = dx;
        dragHelper.dy = dy;

        onAfterMove && onAfterMove.apply( this, arguments );

    },
    moveEnd: function( e, dragHelper, onAfterMoveEnd ) {

        e.preventDefault();
        e.stopImmediatePropagation(); //(stop red dialog dd from closing)

        this.el.animate( {opacity: dragHelper.originalOpacity}, 0, '>' );

        /* Currently not a factory */
        if ( dragHelper.isTransformedShape ) {

            // dx, dy are client coordinates so use
            // an inverse matrix to determine how the
            var invm = Raphael.matrix();
            invm.scale( dragHelper.pageScale, dragHelper.pageScale, 0, 0 );
            invm.rotate( dragHelper.pageRotation, 0, 0 );

            invm = invm.invert();

            dragHelper.invmDx = Math.round( invm.x( dragHelper.dx, dragHelper.dy ) );
            dragHelper.invmDy =  Math.round( invm.y( dragHelper.dx, dragHelper.dy) );

        }


        onAfterMoveEnd && onAfterMoveEnd.apply( this, arguments );

    }
};


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/moveFns/baseMoveFnMixin.js
 ** module id = 190
 ** module chunks = 0
 **/